import templateStr from 'text!./StepperInput.html';
import styles from 'edge/platform/widgets/inputs/stepper/Stepper-hashed.scss';
import cssUtil from 'gw-portals-util-js/CssUtil';

export default [function () {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(templateStr, styles),

        scope: {
            'model': '=',
            'minimumValue': '=',
            'maximumValue': '='
        },
        controller: ['$scope', function ($scope) {

            $scope.canSelectPrevious = function () {
                return $scope.model.value > $scope.minimumValue;
            };
            $scope.canSelectNext = function () {
                return $scope.model.value < $scope.maximumValue;
            };

            $scope.selectPrevValue = function () {
                if ($scope.canSelectPrevious()) {
                    $scope.model.value--;
                }
            };
            $scope.selectNextValue = function () {
                if ($scope.canSelectNext()) {
                    $scope.model.value++;
                }
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/stepper/StepperInput.js
// module id = 785
// module chunks = 0